import axios from '../../api/axios';
import { showSuccess, showError } from '../../Components/reuse/Toast';
import { validateToken } from './validateAction';

// Action Types
export const CONNECT_YOTPO_REQUEST = 'CONNECT_YOTPO_REQUEST';
export const CONNECT_YOTPO_SUCCESS = 'CONNECT_YOTPO_SUCCESS';
export const CONNECT_YOTPO_FAILURE = 'CONNECT_YOTPO_FAILURE';
export const DISCONNECT_YOTPO_REQUEST = 'DISCONNECT_YOTPO_REQUEST';
export const DISCONNECT_YOTPO_SUCCESS = 'DISCONNECT_YOTPO_SUCCESS';
export const DISCONNECT_YOTPO_FAILURE = 'DISCONNECT_YOTPO_FAILURE';

// Action Creators
export const connectYotpoRequest = () => ({
  type: CONNECT_YOTPO_REQUEST
});

export const connectYotpoSuccess = (data) => ({
  type: CONNECT_YOTPO_SUCCESS,
  payload: data
});

export const connectYotpoFailure = (error) => ({
  type: CONNECT_YOTPO_FAILURE,
  payload: error
});

export const connectYotpo = (configData) => {
  return async (dispatch) => {
    dispatch(connectYotpoRequest());
    
    try {
      const response = await axios.post('yotpo/connect', configData);
      
      // Show success message from API response
      showSuccess(response.data.message);
      
      // Update auth data to reflect the new configuration
      dispatch(validateToken());
      
      dispatch(connectYotpoSuccess(response.data));
    } catch (error) {
      console.log(error);
      const errorMessage = error.response?.data?.message || error.response?.data?.error || 'Failed to connect Yotpo';
      showError(errorMessage);
      dispatch(connectYotpoFailure(errorMessage));
    }
  };
};

// Disconnect Yotpo Integration
export const disconnectYotpo = () => {
  return async (dispatch) => {
    dispatch({ type: DISCONNECT_YOTPO_REQUEST });
    try {
      const response = await axios.delete('yotpo/disconnect');
      const data = response?.data || {};
      if (data?.success) {
        showSuccess(data?.message || 'Yotpo disconnected successfully');
        dispatch(validateToken());
        dispatch({ type: DISCONNECT_YOTPO_SUCCESS, payload: data });
        return data;
      }
      const message = data?.message || 'Failed to disconnect Yotpo';
      showError(message);
      dispatch({ type: DISCONNECT_YOTPO_FAILURE, error: message });
      return data;
    } catch (error) {
      const message = error?.response?.data?.message || error?.response?.data?.error || 'Failed to disconnect Yotpo';
      showError(message);
      dispatch({ type: DISCONNECT_YOTPO_FAILURE, error: message });
      return { success: false, message };
    }
  };
};

